import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { preferences, type AppTheme } from '../../../../shared/preferences';
export type { AppTheme } from '../../../../shared/preferences';
const getInitialTheme = () => preferences.getSnapshot().theme;

const themeStore = createSlice({
  name: "theme",
  initialState: {
    theme: getInitialTheme() as AppTheme,
  },
  reducers: {
    setTheme(state, action: PayloadAction<AppTheme>) {
      state.theme = action.payload;
      preferences.setTheme(action.payload);
    },
  },
});

export default themeStore;

export const { setTheme } = themeStore.actions;
